/**
 * generatePreProcessJsonMetadata_DuplicateChecks.ts - Duplicate checking utilities for metadata generation
 * Port of C# GeneratePreProcessJsonMetadata_DuplicateChecks.cs
 * Pure ES module - works in both Node.js and browser via bundler
 */

import type { MissingPlaceholderInfo, MissingSlotholderInfo, MissingJsonKeyInfo } from '../../model/appSiteMetadata.js';

/**
 * Checks if a placeholder already exists in the list
 */
export function isPlaceholderDuplicate(
    list: MissingPlaceholderInfo[],
    placeholderName: string,
    templateName: string,
    templateAppSite: string
): boolean {
    for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if (e.placeholderName === placeholderName &&
            e.templateName === templateName &&
            e.templateAppSite === templateAppSite) {
            return true;
        }
    }
    return false;
}

/**
 * Checks if a slotholder already exists in the list
 */
export function isSlotholderDuplicate(
    list: MissingSlotholderInfo[],
    slotholderName: string,
    templateName: string,
    templateAppSite: string
): boolean {
    for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if (e.slotholderName === slotholderName &&
            e.templateName === templateName &&
            e.templateAppSite === templateAppSite) {
            return true;
        }
    }
    return false;
}

/**
 * Checks if a JSON key already exists in the list
 */
export function isJsonKeyDuplicate(
    list: MissingJsonKeyInfo[],
    jsonKey: string,
    templateName: string,
    templateAppSite: string
): boolean {
    for (let i = 0; i < list.length; i++) {
        const e = list[i];
        if (e.jsonKey === jsonKey &&
            e.templateName === templateName &&
            e.templateAppSite === templateAppSite) {
            return true;
        }
    }
    return false;
}
